import { ReactNode, useMemo } from 'react';
import { initI18n } from '@/features/i18n/utils/initI18n';
import { I18nextProvider } from 'react-i18next';

export interface I18nProviderProps {
  children?: ReactNode;
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const i18n = useMemo(() => initI18n(), []);
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
